<template>
  <div v-if="logo.code === 'AirIQ'">
    <img
      src="@/assets/integrations/truckerTools/AirIQ.svg"
      alt="AirIQ"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'Anytrek'">
    <img
      src="@/assets/integrations/truckerTools/Anytrek.svg"
      alt="Anytrek"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'AVLTrack'">
    <img
      src="@/assets/integrations/truckerTools/AVLTrack.svg"
      alt="AVLTrack"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'Azuga'">
    <img
      src="@/assets/integrations/truckerTools/Azuga.svg"
      alt="Azuga"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'bigRoad'">
    <img
      src="@/assets/integrations/truckerTools/BigRoad.svg"
      alt="BigRoad"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'BIT'">
    <img
      src="@/assets/integrations/truckerTools/BIT.svg"
      alt="BIT"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'CyntrX'">
    <img
      src="@/assets/integrations/truckerTools/CyntrX.svg"
      alt="CyntrX"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'Dumax'">
    <img
      src="@/assets/integrations/truckerTools/Dumax.svg"
      alt="Dumax"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'ERoad'">
    <img
      src="@/assets/integrations/truckerTools/ERoad.svg"
      alt="ERoad"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'FleetHunt'">
    <img
      src="@/assets/integrations/truckerTools/FleetHunt.svg"
      alt="FleetHunt"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'FlexFleet'">
    <img
      src="@/assets/integrations/truckerTools/FlexFleet.svg"
      alt="FlexFleet"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'geotab'">
    <img
      src="@/assets/integrations/truckerTools/geoTab.svg"
      alt="geoTab"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'Gorilla'">
    <img
      src="@/assets/integrations/truckerTools/Gorilla.svg"
      alt="Gorilla"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'GPSInsight'">
    <img
      src="@/assets/integrations/truckerTools/GPSInsight.svg"
      alt="GPSInsight"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'GPSTab'">
    <img
      src="@/assets/integrations/truckerTools/GPSTab.svg"
      alt="GPSTab"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'Hutch'">
    <img
      src="@/assets/integrations/truckerTools/Hutch.svg"
      alt="Hutch"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'Isaac'">
    <img
      src="@/assets/integrations/truckerTools/Isaac.svg"
      alt="Isaac"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'KeepTrucking'">
    <img
      src="@/assets/integrations/truckerTools/KeepTrucking.svg"
      alt="keepTrucking"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'keller'">
    <img
      src="@/assets/integrations/truckerTools/keller.svg"
      alt="keller"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'LinxUp'">
    <img
      src="@/assets/integrations/truckerTools/LinxUp.svg"
      alt="LinxUp"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'm2m'">
    <img
      src="@/assets/integrations/truckerTools/m2m.svg"
      alt="m2m"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'MixTelematics'">
    <img
      src="@/assets/integrations/truckerTools/MixTelematics.svg"
      alt="mixTelematics"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'Nationwide'">
    <img
      src="@/assets/integrations/truckerTools/Nationwide.svg"
      alt="Nationwide"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'NeroGlobal'">
    <img
      src="@/assets/integrations/truckerTools/NeroGlobal.svg"
      alt="NeroGlobal"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'omnitrac'">
    <img
      src="@/assets/integrations/truckerTools/omnitrac.svg"
      alt="omnitrac"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'OneStepGPS'">
    <img
      src="@/assets/integrations/truckerTools/OneStepGPS.svg"
      alt="OneStepGPS"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'Pedigree'">
    <img
      src="@/assets/integrations/truckerTools/Pedigree.svg"
      alt="Pedigree"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'PowerFleet'">
    <img
      src="@/assets/integrations/truckerTools/PowerFleet.svg"
      alt="PowerFleet"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'RandMcNallyDC'">
    <img
      src="@/assets/integrations/truckerTools/RandMcNally.svg"
      alt="RandyMcNally"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'RandMcNally'">
    <img
      src="@/assets/integrations/truckerTools/RandMcNally.svg"
      alt="RandyMcNally"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'Rhino'">
    <img
      src="@/assets/integrations/truckerTools/Rhino.svg"
      alt="Rhino"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'Samsara'">
    <img
      src="@/assets/integrations/truckerTools/samsara.svg"
      alt="Samsara"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'SimpleTruck'">
    <img
      src="@/assets/integrations/truckerTools/SimpleTruck.svg"
      alt="SimpleTruck"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'ThinAir'">
    <img
      src="@/assets/integrations/truckerTools/ThinAir.svg"
      alt="ThinAin"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'TrackEnsure'">
    <img
      src="@/assets/integrations/truckerTools/TrackEnsure.svg"
      alt="TrackEnsure"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'TruckX'">
    <img
      src="@/assets/integrations/truckerTools/TruckX.svg"
      alt="TruckX"
      :class="className"
    />
  </div>
  <div v-else-if="logo.code === 'Verizon'">
    <img
      src="@/assets/integrations/truckerTools/Verizon.svg"
      alt="Verizon"
      :class="className"
    />
  </div>
  <div v-else>
    <p>{{ capitalizeFirstLetter(logo?.name) }}</p>
  </div>
</template>

<script>
export default {
  name: 'TruckerToolLogo',
  props: {
    logo: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    className: {
      type: String,
      default: '',
      required: false,
    },
  },

  methods: {
    capitalizeFirstLetter(sentence) {
      return (
        sentence?.charAt(0)?.toUpperCase() + sentence?.slice(1) || sentence
      );
    },
  },
};
</script>
